var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVsCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0016 3.11679C21.0016 2.23783 20.0175 2.23782 19.5801 2.34769C20.1924 1.86426 20.9105 1.98147 21.1656 2.12796L27.079 5.02747C27.6424 5.30375 27.9998 5.8786 27.9998 6.50857V25.5831C27.9998 26.2215 27.6329 26.8025 27.058 27.0743L21.4937 29.7054C21.1109 29.8701 20.2799 30.2767 19.5801 29.7053C20.4549 29.8702 20.9287 29.2476 21.0016 28.8264V3.11679Z",
    fill: "url(#paint0_linear_87_8101)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6512 2.3319C20.1154 2.24017 21.0018 2.28271 21.0018 3.11685V9.68254L3.07359 23.2453C2.76022 23.4824 2.3192 23.443 2.05229 23.1542L0.204532 21.1548C-0.0849358 20.8416 -0.0646824 20.3513 0.249624 20.0633L19.5802 2.34775L19.6512 2.3319Z",
    fill: "url(#paint1_linear_87_8101)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0018 22.3708L3.07359 8.80801C2.76022 8.57094 2.3192 8.61028 2.05229 8.8991L0.204532 10.8985C-0.0849358 11.2117 -0.0646824 11.702 0.249624 11.9901L19.5802 29.7056C20.455 29.8704 20.9289 29.2478 21.0018 28.8266V22.3708Z",
    fill: "url(#paint2_linear_87_8101)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_8101",
    x1: 23.79,
    y1: 2,
    x2: 23.79,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B9FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_8101",
    x1: 21.0018,
    y1: 5.53398,
    x2: 1.0217,
    y2: 22.3051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270551,
    stopColor: "#1279B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421376,
    stopColor: "#1176B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618197,
    stopColor: "#0E69AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855344,
    stopColor: "#0F70AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_8101",
    x1: 1.15522,
    y1: 9.98389,
    x2: 21.0791,
    y2: 26.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1791D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1173C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsCode);
export default __webpack_public_path__ + "static/media/vsCode.3d8fea0ed9043ed9bf421bbdb507a21e.svg";
export { ForwardRef as ReactComponent };